import api from './client'

export async function fetchDashboardWidgets() {
  const { data } = await api.get('/widgets/dashboard')
  return data
}

export async function fetchPersonalDashboard(params = {}) {
  const { data } = await api.get('/dashboard/personal', { params })
  return data
}

export async function fetchFinancialDashboard(params = {}) {
  const { data } = await api.get('/dashboard/financial', { params })
  return data
}

export async function fetchFinancialDashboardDrilldown(params = {}) {
  const { data } = await api.get('/dashboard/financial/drilldown', { params })
  return data
}

export async function fetchTeamDashboardFilters(params = {}) {
  const { data } = await api.get('/dashboard/team/filters', { params })
  return data
}

export async function fetchTeamDashboard(params = {}) {
  const { data } = await api.get('/dashboard/team', { params })
  return data
}

export async function fetchTeamDashboardAvailability(params = {}) {
  const { data } = await api.get('/dashboard/team/availability', { params })
  return data
}

export async function fetchTeamDashboardSchedule(params = {}) {
  const { data } = await api.get('/dashboard/team/schedule', { params })
  return data
}

export async function fetchTeamDashboardSla(params = {}) {
  const { data } = await api.get('/dashboard/team/sla', { params })
  return data
}

export async function fetchTeamDashboardDrilldown(params = {}) {
  const { data } = await api.get('/dashboard/team/drilldown', { params })
  return data
}

export async function fetchCalendarView(params = {}) {
  const { data } = await api.get('/calendar/view', { params })
  return data
}

export async function createCalendarMeeting(body) {
  const { data } = await api.post('/calendar/events/meeting', body)
  return data
}

export async function createCalendarWorkTime(body) {
  const { data } = await api.post('/calendar/events/work-time', body)
  return data
}

export async function updateCalendarEvent({ eventId, ...body }) {
  const { data } = await api.patch(`/calendar/events/${eventId}`, body)
  return data
}

export async function deleteCalendarEvent(eventId) {
  const { data } = await api.delete(`/calendar/events/${eventId}`)
  return data
}

export async function checkCalendarAvailability(body) {
  const { data } = await api.post('/calendar/availability/check', body)
  return data
}

export async function shareCalendarAvailability(body) {
  const { data } = await api.post('/calendar/availability/share', body)
  return data
}

export async function createLeave(body) {
  const { data } = await api.post('/leaves', body)
  return data
}

export async function fetchCalendarSharingSettings() {
  const { data } = await api.get('/calendar/sharing-settings')
  return data
}

export async function updateCalendarSharingSettings(body) {
  const { data } = await api.patch('/calendar/sharing-settings', body)
  return data
}

export async function fetchChartTypes() {
  const { data } = await api.get('/widgets/options/chart-types')
  return data?.chart_types || data
}

export async function fetchAggregationTypes() {
  const { data } = await api.get('/widgets/options/aggregations')
  return data?.aggregation_types || data
}

export async function fetchDatasets() {
  const { data } = await api.get('/widgets/datasets')
  return data
}

export async function fetchDatasetFields(datasetKey) {
  const { data } = await api.get(`/widgets/dataset/${datasetKey}/fields`)
  return data
}

export async function createWidget(widgetConfig) {
  const { data } = await api.post('/widgets', {
    name: widgetConfig.name,
    dataset: widgetConfig.dataset,
    x_axis: widgetConfig.xAxis,
    y_axis: widgetConfig.yAxis,
    aggregation: widgetConfig.aggregation,
    chart_type: widgetConfig.chartType,
  })
  return data
}

export async function assignWidget({ widgetId, roleIds, displayOrder }) {
  const { data } = await api.post('/widgets/assign', {
    widget_id: widgetId,
    role_ids: roleIds,
    display_order: displayOrder,
  })
  return data
}
